// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JWbC","toggle":"styles_toggle__z1X2c","preview":"styles_preview__28vFC"};